import { applyProviderNumber, reDistruProvider } from '@/api/logisticsOrders/index.js';
export default {
  clickapplyForProvider() {
    if (this.selectionList.length !== 0) {
      const status = [2, 3];
      if (this.selectionList.length === 1) {
        if (status.includes(this.selectionList[0].providerOrderStatus)) {
          this.$message.error(this.$t('navbar.tip02'));
          return;
        }
      }
      const data = {
        waybillNumberList: [],
        waybillIds: [],
        providerNameList: []
      };
      console.log(data, 'data.waybillNumberList');
      this.selectionList.forEach(item => {
        if (!status.includes(item.providerOrderStatus)) {
          data.waybillNumberList.push(item.waybillNumber);
          if (item.providerName) {
            data.providerNameList.push(item.providerName);
          }
          data.waybillIds.push(item.id);
        }
      });
      if (data.waybillNumberList.length === 0) {
        this.$message.error(this.$t('navbar.tip02'));
        return;
      }
      console.log(this.selectionList, 'this.selectionList');
      const h = this.$createElement;
      this.$msgbox({
        title: this.$i18n.t('operationCenter.tips'),
        message: h('p', null, [
          h('span', this.$i18n.t('navbar.tip03')) // 确定要选中单号进行申请服务商单号吗
        ]),
        showCancelButton: true,
        confirmButtonText: this.$i18n.t('GlobalSetObj.determine'),
        cancelButtonText: this.$i18n.t('GlobalSetObj.cancel')
      })
        .then((action) => {
          if (action === 'confirm') {
            // return;
            applyProviderNumber(data).then(res => {
              if (res.status === 'OK') {
                this.getSearch();
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              }
            });
            console.log('确定');
          }
        })
        .catch(() => {
          console.log('取消');
        });
    } else {
      this.$message.warning(this.$t('GlobalSetObj.CheckForm'));
    }
  },
  reallocate() {
    const statusArr = [1, 4];
    const waybillNumberList = [];
    if (this.selectionList.length !== 0) {
      if (this.selectionList.length === 1) {
        if (!statusArr.includes(this.selectionList[0].providerOrderStatus)) {
          this.$message.error(this.$t('navbar.tip04'));
          return;
        }
      }
      this.selectionList.forEach(item => {
        if (statusArr.includes(item.providerOrderStatus)) {
          waybillNumberList.push(item.waybillNumber);
          this.waybillIds.push(item.id);
        }
      });
      if (waybillNumberList.length === 0) {
        this.$message.error(this.$t('navbar.tip04'));
        return;
      }
      this.reDistruForm.reProviderDialog = true;
    } else {
      this.$message.warning(this.$t('GlobalSetObj.CheckForm'));
    }
  },
  selectTable(data) {
    this.selectionList = data;
    this.waybillIds = [];
  },
  trajectoryQuery(row) {
    this.queryTrackParam = row;
    console.log(row, ':query-track-param="queryTrackParam"');
    this.showQueryTrack.visible = true;
    this.showQueryTrack.trackKey = new Date().getTime();
  },
  toOrderDetail(row) {
    this.showQueryTrack.trackKey = new Date().getTime();
    const statusArr = [2, 3];
    const { id, providerOrderStatus } = row;
    this.waybillDescription.visible = true;
    this.waybillDescription.ids = id;

    // 如果当前订单是 取号成功或取号中（2,3） 则不能编辑
    if (statusArr.includes(providerOrderStatus)) {
      this.waybillDescription.isEdit = false;
    } else {
      this.waybillDescription.isEdit = true;
    }
  },
  handleSizeChange(val) {
    this.queryForm.pageNumber = 1;
    this.queryForm.pageSize = val;
    this.getSearch();
  },
  handleCurrentChange(val) {
    this.queryForm.pageNumber = val;
    this.getSearch();
  },
  handleReProviderDialog() {
    this.reDistruForm.providerId = '';
    this.senderInformationId = '';
  },
  comfirmDistru() {
    if (this.reDistruForm.providerId) {
      const arr = this.reDistruForm.providerId.split(',');
      const data = {
        waybillIds: this.waybillIds,
        providerId: arr[0],
        providerName: arr[1],
        providerCode: arr[2]
      };
      reDistruProvider(data).then(res => {
        if (res.status === 'OK') {
          this.getSearch();
          this.reDistruForm.reProviderDialog = false;
          this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
        }
      });
    } else {
      this.$message.warning(this.$t('navbar.pleaseSelectProvider'));
    }
  }
};
